<template>
  <div>
    <Loading :loading="loading" />
    <EditCamposSistema
      :entidade="entidadeSelecionada"
      :contexto="contextoSelecionado"
      :campos="camposEditados"
      :gatilhos="gatilhos"
      :presets="presets"
      :secoes="secoes"
      :config-form="configForm"
      :config-form-schema="configFormSchema"
      :modelos="modelos"
      :sistema="sistemaSelecionado"
      :close="closeEdit"
      :onSubmit="onSubmit"
      @criar-modelo="criarModelo"
      @atualizar-modelo="atualizarModelo"
      @excluir-modelo="excluirModelo"
      @sistema-changed="onSistemaChanged"
    />

    <CAlert show color="light">
      Configure, para cada cadastro, quais campos são <strong>visíveis</strong> e
      <strong>obrigatórios</strong> e crie <strong>regras condicionais</strong>
      (ex.: tornar a Inscrição Estadual obrigatória para certos CNAEs). A aplicação de cada
      configuração é indicada ao abrir o cadastro.
    </CAlert>

    <div class="entidades-grid">
      <div
        v-for="(entidade, chaveEntidade) in entidades"
        :key="chaveEntidade"
        class="entidade-card"
      >
        <div class="entidade-header">
          <div class="entidade-icon">
            <fa-icon :icon="getIconeEntidade(chaveEntidade)" />
          </div>
          <div class="entidade-info">
            <div class="entidade-nome">{{ entidade.titulo }}</div>
            <div class="entidade-desc">{{ Object.keys(entidade.contextos || {}).length }} contexto(s)</div>
          </div>
        </div>

        <div class="contextos-list">
          <div
            v-for="(contexto, chaveContexto) in (entidade.contextos || {})"
            :key="chaveContexto"
            class="contexto-item"
            @click="openEdit(chaveEntidade, chaveContexto, contexto)"
          >
            <div class="contexto-info">
              <div class="contexto-nome">{{ contexto.titulo }}</div>
              <div class="contexto-desc">{{ contexto.descricao }}</div>
            </div>
            <fa-icon icon="pencil-alt" class="contexto-edit-icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, put, post, del } from '../../helpers/apiRequest';
import clone from 'just-clone';
import EditCamposSistema from './components/EditCamposSistema.vue';

export default {
  name: 'CadastroFormularios',
  components: { EditCamposSistema },
  data() {
    return {
      loading: false,
      entidades: {},
      camposEditados: [],
      gatilhos: [],
      presets: [],
      secoes: [],
      configForm: {},
      configFormSchema: [],
      modelos: [],
      entidadeSelecionada: {},
      contextoSelecionado: {},
      sistemaSelecionado: null,
    };
  },
  methods: {
    getIconeEntidade(chave) {
      const icones = { cliente: 'user', orcamento: 'clipboard-list', ticket: 'headset' };
      return icones[chave] || 'cogs';
    },
    loadEntidades() {
      this.loading = true;
      get('/admin/cadastro-campos/entidades')
        .then((response) => {
          this.entidades = response;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({ title: 'Ops!', text: err.message, icon: 'error' });
        });
    },
    openEdit(chaveEntidade, chaveContexto, contexto) {
      this.entidadeSelecionada = { chave: chaveEntidade, titulo: this.entidades[chaveEntidade].titulo };
      this.contextoSelecionado = {
        chave: chaveContexto,
        titulo: contexto.titulo,
        descricao: contexto.descricao,
      };
      // entidade cliente tem configs independentes por sistema (Call/FV)
      this.sistemaSelecionado = chaveEntidade === 'cliente' ? 'CALLCENTER' : null;

      // modelos são por entidade (não compartilhados entre cadastros)
      this.loadModelos(chaveEntidade);

      this.carregarCatalogo(() => this.$modal.show('editCamposSistema'));
    },
    carregarCatalogo(callback) {
      const entidade = this.entidadeSelecionada.chave;
      const contexto = this.contextoSelecionado.chave;
      const qs = this.sistemaSelecionado ? `?sistema=${this.sistemaSelecionado}` : '';
      this.loading = true;
      get(`/admin/cadastro-campos/${entidade}/${contexto}${qs}`)
        .then((response) => {
          this.camposEditados = clone(response.campos || []);
          this.gatilhos = response.gatilhos || [];
          this.presets = response.presets || [];
          this.secoes = response.secoes || [];
          this.configForm = response.configForm || {};
          this.configFormSchema = response.configFormSchema || [];
          this.loading = false;
          if (callback) callback();
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({ title: 'Ops!', text: err.message, icon: 'error' });
        });
    },
    onSistemaChanged(sistema) {
      this.sistemaSelecionado = sistema;
      this.carregarCatalogo();
    },
    closeEdit() {
      this.$modal.hide('editCamposSistema');
    },
    // ───── Modelos de regra (por entidade — não compartilhados entre cadastros) ─────
    loadModelos(entidade) {
      const ent = entidade || this.entidadeSelecionada.chave;
      if (!ent) return;
      get(`/admin/cadastro-regra-modelos/${ent}`)
        .then((response) => {
          this.modelos = Array.isArray(response) ? response : response.data || [];
        })
        .catch(() => {
          this.modelos = [];
        });
    },
    criarModelo(payload) {
      post('/admin/cadastro-regra-modelos', { ...payload, entidade: this.entidadeSelecionada.chave })
        .then(() => {
          this.$swal({ title: 'Modelo salvo!', icon: 'success', timer: 1500, showConfirmButton: false });
          this.loadModelos();
        })
        .catch((err) => this.$swal({ title: 'Ops!', text: err.message, icon: 'error' }));
    },
    atualizarModelo(modelo) {
      put(`/admin/cadastro-regra-modelos/${modelo.id}`, {
        entidade: modelo.entidade || this.entidadeSelecionada.chave,
        nome: modelo.nome,
        descricao: modelo.descricao,
        efeito: modelo.efeito,
        conector: modelo.conector || 'E',
        rotulo: modelo.rotulo || null,
        condicoes: modelo.condicoes || [],
      })
        .then(() => this.loadModelos())
        .catch((err) => this.$swal({ title: 'Ops!', text: err.message, icon: 'error' }));
    },
    excluirModelo(modelo) {
      del(`/admin/cadastro-regra-modelos/${modelo.id}`)
        .then(() => this.loadModelos())
        .catch((err) => this.$swal({ title: 'Ops!', text: err.message, icon: 'error' }));
    },
    onSubmit({ campos, secoes }) {
      this.loading = true;
      const entidade = this.entidadeSelecionada.chave;
      const contexto = this.contextoSelecionado.chave;

      put(`/admin/cadastro-campos/${entidade}/${contexto}`, { campos, secoes })
        .then((response) => {
          this.$swal({ title: 'Sucesso!', text: response.message, icon: 'success' });
          this.closeEdit();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({ title: 'Ops!', text: err.message, icon: 'error' });
        });
    },
  },
  beforeMount() {
    this.loadEntidades();
  },
};
</script>

<style scoped>
.entidades-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  margin-top: 16px;
}
.entidade-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.entidade-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}
.entidade-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eceaf3;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3a3e81;
  font-size: 16px;
  flex-shrink: 0;
}
.entidade-nome {
  font-weight: 600;
  font-size: 15px;
  color: #1d2939;
}
.entidade-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 2px;
}
.contextos-list {
  padding: 8px 0;
}
.contexto-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  cursor: pointer;
  transition: background 0.15s;
}
.contexto-item:hover {
  background: #f9fafb;
}
.contexto-nome {
  font-weight: 500;
  font-size: 14px;
  color: #344054;
}
.contexto-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 2px;
}
.contexto-edit-icon {
  color: #98a2b3;
  font-size: 13px;
  transition: color 0.15s;
}
.contexto-item:hover .contexto-edit-icon {
  color: #3a3e81;
}
</style>
